export const SET_ADDRESS_OPTIONS = 'SET_ADDRESS_OPTIONS';
export const CLEAR_ADDRESS_OPTIONS = 'CLEAR_ADDRESS_OPTIONS';
export const MAKE_CALL_ON_OPEN = 'MAKE_CALL_ON_OPEN';
export const DONT_MAKE_CALL_ON_OPEN = 'DONT_MAKE_CALL_ON_OPEN';
export const MAKE_SILENT_CALL_ON_OPEN = 'MAKE_SILENT_CALL_ON_OPEN';
export const DONT_MAKE_SILENT_CALL_ON_OPEN = 'DONT_MAKE_SILENT_CALL_ON_OPEN';
export const SET_AVAILABLE_NEARBY = 'SET_AVAILABLE_NEARBY';
export const SET_LEGIT_CALL = 'SET_LEGIT_CALL';
export const UNSET_LEGIT_CALL = 'UNSET_LEGIT_CALL';